/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum DoorstroomExt {
    DOORSTROOM = "Doorstroom",
    OPSTROOM = "Opstroom",
    DOUBLURE = "Doublure",
    AFGEWEZEN = "Afgewezen",
    AFSTROOM = "Afstroom",
    GESLAAGD = "Geslaagd",
    DOORSTROOM_EXTERN = "Doorstroom (extern)",
    OPSTROOM_EXTERN = "Opstroom (extern)",
    DOUBLURE_EXTERN = "Doublure (extern)",
    AFGEWEZEN_EXTERN = "Afgewezen (extern)",
    AFSTROOM_EXTERN = "Afstroom (extern)",
    INSTROOM = "Instroom"
}
